import {fetchBody, URL_CUSTOMERPOSITION_ADD, URL_POSITIONDEMAND_GET_DETAIL, URL_RECUITMENTCONTRACTOR_GET_LIST, URL_RECUITMENTCONTRACTOR_GET_PROCESS_LIST, URL_RECUITMENTCONTRACTOR_SET_BLACKLIST} from "../config"
import { toLogout, cleanFetch } from "./apiTools";
import { getToken } from "../component/Login/Auth";

export function api_getRecruitmentContractorStatusList ({mReqRecruitmentContractorStatusList, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqRecruitmentContractorStatusList, token}), 
      url: URL_RECUITMENTCONTRACTOR_GET_LIST, 
      success,
      failure
    })
  }
}

export function api_addCustomerPosition ({mRespCustomerPosition, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mRespCustomerPosition, token}), 
      url: URL_CUSTOMERPOSITION_ADD, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_getPositionDemandDetail ({mReqCustomerPositionDetail, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqCustomerPositionDetail, token}), 
      url: URL_POSITIONDEMAND_GET_DETAIL, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_getRecruitmentContractorStatusProcessList ({mReqRecruitmentContractorStatusProcessList, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqRecruitmentContractorStatusProcessList, token}), 
      url: URL_RECUITMENTCONTRACTOR_GET_PROCESS_LIST, 
      success,
      failure
    })
  }
}

export function api_setBlacklist ({mReqBlacklist, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    console.log(mReqBlacklist)
    cleanFetch({
      body: fetchBody({body: mReqBlacklist, token}), 
      url: URL_RECUITMENTCONTRACTOR_SET_BLACKLIST, 
      success,
      failure
    })
  }
}